var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 37,
    rx: 5,
    fill: "url(#paint0_linear_224_707)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 26.6666H28V28H8V26.6666Z",
    fill: "url(#paint1_linear_224_707)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9999 15.3334C10.7347 15.3334 10.4803 15.4387 10.2928 15.6263C10.1052 15.8138 9.99988 16.0682 9.99988 16.3334V25.3334H13.9999V16.3334C13.9999 16.0682 13.8945 15.8138 13.707 15.6263C13.5194 15.4387 13.2651 15.3334 12.9999 15.3334H10.9999Z",
    fill: "url(#paint2_linear_224_707)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0001 20.6666C16.7349 20.6666 16.4806 20.772 16.293 20.9595C16.1055 21.1471 16.0001 21.4014 16.0001 21.6666V25.3333H20.0001V21.6666C20.0001 21.4014 19.8948 21.1471 19.7072 20.9595C19.5197 20.772 19.2653 20.6666 19.0001 20.6666H17.0001Z",
    fill: "url(#paint3_linear_224_707)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23 22.6666C22.7348 22.6666 22.4804 22.772 22.2929 22.9595C22.1054 23.1471 22 23.4014 22 23.6666V25.3333H26V23.6666C26 23.4014 25.8946 23.1471 25.7071 22.9595C25.5196 22.772 25.2652 22.6666 25 22.6666H23Z",
    fill: "url(#paint4_linear_224_707)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2001 16.72C16.4217 17.4574 16.8246 18.1275 17.3719 18.669C17.9193 19.2106 18.5937 19.6063 19.3334 19.82C19.7677 19.9399 20.2162 20.0005 20.6668 20C21.9044 20 23.0914 19.5083 23.9666 18.6331C24.8418 17.758 25.3334 16.571 25.3334 15.3333C25.3334 15.1565 25.2632 14.9869 25.1382 14.8619C25.0131 14.7369 24.8436 14.6666 24.6668 14.6666H22.3334C22.0682 14.6666 21.8139 14.5613 21.6263 14.3737C21.4388 14.1862 21.3334 13.9319 21.3334 13.6666V11.3333C21.3334 11.1565 21.2632 10.9869 21.1382 10.8619C21.0131 10.7369 20.8436 10.6666 20.6668 10.6666C19.9707 10.6653 19.2832 10.8196 18.6545 11.1184C18.0258 11.4171 17.4719 11.8527 17.0334 12.3933C16.5531 12.9923 16.2261 13.6995 16.0809 14.4534C15.9357 15.2074 15.9766 15.9854 16.2001 16.72Z",
    fill: "url(#paint5_linear_224_707)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3333 13.3333H27.3333C27.5101 13.3333 27.6797 13.2631 27.8047 13.1381C27.9297 13.013 28 12.8435 28 12.6667C28 11.429 27.5083 10.242 26.6331 9.36683C25.758 8.49167 24.571 8 23.3333 8C23.1565 8 22.9869 8.07024 22.8619 8.19526C22.7369 8.32029 22.6666 8.48986 22.6666 8.66667V12.34C22.6666 13.0333 22.9666 13.3333 23.3333 13.3333Z",
    fill: "url(#paint6_linear_224_707)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8 8H17.3333V9.33333H8V8Z",
    fill: "url(#paint7_linear_224_707)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8 10.6666H14V12H8V10.6666Z",
    fill: "url(#paint8_linear_224_707)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_224_707",
    x1: 0,
    y1: 0,
    x2: 37,
    y2: 37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C4B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#70EFDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_224_707",
    x1: 26.582,
    y1: 26.9074,
    x2: 8.5849,
    y2: 35.7092,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_224_707",
    x1: 13.7163,
    y1: 17.1392,
    x2: 9.25668,
    y2: 17.1973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_224_707",
    x1: 19.7165,
    y1: 21.5093,
    x2: 15.2596,
    y2: 21.6339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_224_707",
    x1: 25.7164,
    y1: 23.1482,
    x2: 21.2667,
    y2: 23.3658,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_224_707",
    x1: 24.6714,
    y1: 12.352,
    x2: 14.2701,
    y2: 12.6913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_224_707",
    x1: 27.6218,
    y1: 8.96309,
    x2: 21.681,
    y2: 9.15679,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_224_707",
    x1: 16.6716,
    y1: 8.24077,
    x2: 6.77939,
    y2: 10.4985,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_224_707",
    x1: 13.5746,
    y1: 10.9074,
    x2: 7.02506,
    y2: 11.8683,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.138993d974615f04d994685c8fab315a.svg";
export { ForwardRef as ReactComponent };